<template>
  <div class="appbigbox">
    <router-view name="home"></router-view>
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  
}
</script>
<style lang="less" scoped>
  .appbigbox{
    height: 100vh;
    width: 100%;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
</style>
